import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Kept for back-compat — Portal V2 is now the default at /portal/*.
 * Always returns true so any caller suppresses preview banners.
 */
export const isPreviewEnv = () => true;

/**
 * <PortalV2LegacyRedirect />
 *
 * Mount once inside the Router. Transparently redirects any legacy
 * `/portal-v2/*` URL (old bookmarks, emails sent before the cutover) back
 * to the canonical `/portal/*` URL — preserving query string + hash.
 */
export const PortalV2LegacyRedirect = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const path = location.pathname;
    if (!path.startsWith('/portal-v2')) return;

    const newPath = path.replace(/^\/portal-v2(\/|$)/, '/portal$1');
    if (newPath === path) return;

    navigate(newPath + location.search + location.hash, { replace: true });
  }, [location, navigate]);

  return null;
};

// Back-compat alias — old App.js imports may still reference this name.
export const PreviewPortalRedirect = PortalV2LegacyRedirect;

export default PortalV2LegacyRedirect;
